<template>
    <div v-if="msgRef === ''" class="loader" :style="style">
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
    </div>
    <div v-else :class="[`loading`, {error: isError}]">{{ msgRef }}</div>
</template>

<script setup>
import {defineProps,watch,ref} from 'vue'
const props = defineProps({
    msg     : String,
    isError : Boolean,
    style   : Object
});

// const msgRef = ref(props.msg || "Loading");
// watch(() => props.msg, (newVal) => {
//     msgRef.value = newVal || "Loading";
// })

const msgRef = ref(props.msg);
watch(() => props.msg, (newVal) => {
    msgRef.value = newVal;
    console.log('msgRef',msgRef);
    
})
</script>
<style scoped lang="scss">
@import "@/assets/scss/components/common/loading/loading.scss";
</style>